import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Row, Col, Label, FormGroup, Input } from 'reactstrap';
import { func, object } from 'prop-types';
import IframeConstructorColorPicker from './IframeConstructorColorPicker';
import IframeConstructorRangeControl from './IframeConstructorRangeControl';
import CustomControl from '../CustomControl/CustomControl';

class IframeConstructorFieldsControls extends Component {
  static propTypes = {
    handleFieldChange: func.isRequired,
    validateFieldColor: func.isRequired,
    settings: object.isRequired,
    config: object.isRequired,
  };

  state = {
    height: 0,
    maxWidth: 0,
  };

  componentDidMount() {
    this.setState(() => ({
      height: this.props.settings.field.height,
      maxWidth: this.props.settings.field.maxWidth,
    }));
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.settings.field.height !== this.props.settings.field.height ||
      prevProps.settings.field.maxWidth !== this.props.settings.field.maxWidth
    ) {
      this.setState(() => ({
        height: this.props.settings.field.height,
        maxWidth: this.props.settings.field.maxWidth,
      }));
    }
  }

  handleChange = e => {
    const { value, name } = e.target;
    this.setState(() => ({
      [name]: value,
    }));
  };

  render() {
    const { settings, config, handleFieldChange, validateFieldColor } = this.props;
    const { height, maxWidth } = this.state;
    return (
      <div className="iframe-constructor-controls-block">
        <h3 className="iframe-constructor-controls-block-title">
          <FormattedMessage
            id="iframe_constructor.сontrols.fields.title"
            defaultMessage="Form fields"
          />
        </h3>

        <Row>
          <Col md="6">
            <IframeConstructorColorPicker
              name="bgColor"
              value={settings.field.bgColor}
              onChange={handleFieldChange}
              validate={validateFieldColor.bind(null, 'bgColor', config.field._DEFAULT_BG_COLOR)}
              id="ic--field-bg-color"
              label={{
                id: 'iframe_constructor.сontrols.fields.color.bg',
                defaultMessage: 'Field background color',
              }}
            />
          </Col>
          <Col md="6">
            <IframeConstructorColorPicker
              name="textColor"
              value={settings.field.textColor}
              onChange={handleFieldChange}
              validate={validateFieldColor.bind(
                null,
                'textColor',
                config.field._DEFAULT_TEXT_COLOR,
              )}
              id="ic--field-text-color"
              label={{
                id: 'iframe_constructor.сontrols.fields.color.text',
                defaultMessage: 'Field text color',
              }}
            />
          </Col>
        </Row>

        <FormGroup>
          <Label for="iframe-constructor-field-height" className="no-margin">
            <FormattedMessage
              id="iframe_constructor.сontrols.fields.height.text"
              defaultMessage="Field height (px)"
            />
          </Label>
          <Row>
            <Col md="9">
              <IframeConstructorRangeControl
                value={settings.field.height}
                max={config.field._MAX_HEIGHT}
                min={config.field._MIN_HEIGHT}
                onChange={handleFieldChange}
                name="height"
              />
            </Col>

            <Col md="3">
              <Input
                type="number"
                id="iframe-constructor-field-height"
                name="height"
                onChange={this.handleChange}
                onBlur={handleFieldChange}
                value={height}
                min={config.field._MIN_HEIGHT}
                max={config.field._MAX_HEIGHT}
                bsSize="sm"
              />
            </Col>
          </Row>
        </FormGroup>

        <FormGroup>
          <CustomControl
            id="ic__field-max-width-status"
            name="enabledMaxWidth"
            type="checkbox"
            className="custom-control-xs"
            value={'enabledMaxWidth'}
            onChange={handleFieldChange}
            checked={settings.field.enabledMaxWidth}
          >
            <FormattedMessage
              id="iframe_constructor.сontrols.fields.maxWidth.text"
              defaultMessage="Maximum width of the field (px)"
            />
          </CustomControl>

          <Row>
            <Col md="9">
              <IframeConstructorRangeControl
                value={settings.field.maxWidth}
                max={config.field._MAX_WIDTH}
                min={config.field._MIN_WIDTH}
                onChange={handleFieldChange}
                name="maxWidth"
                disabled={!settings.field.enabledMaxWidth}
              />
            </Col>

            <Col md="3">
              <Input
                type="number"
                id="iframe-constructor-field-max-width"
                name="maxWidth"
                onChange={this.handleChange}
                onBlur={handleFieldChange}
                value={maxWidth}
                min={config.field._MIN_WIDTH}
                max={config.field._MAX_WIDTH}
                bsSize="sm"
                disabled={!settings.field.enabledMaxWidth}
              />
            </Col>
          </Row>
        </FormGroup>
      </div>
    );
  }
}

export default IframeConstructorFieldsControls;
